import { Link, Text, View } from '@react-pdf/renderer';
import styles from './styles';
import { CheckboxSelectedSVG, CheckboxSVG } from './svgs/Checkbox';
import { MitigationMeasures } from '@components/Activity/types/MitigationMeasures';
import { PreventionMeasures } from '@components/Activity/types/PreventionMeasures';
import { AffectedGroupState } from '@components/Activity/types/AffectedGroupState';
import { FlammableCategory } from '@components/Activity/types/FlammableCategory';
import { OrganisationalMeasures } from '@components/Activity/types/OrganisationalMeasures';
import { useTranslation } from 'react-i18next';
import { getEDMSLink } from './Util';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { WorkerTrainingInformation } from '@components/Activity/types/WorkerTrainingInformation';

type Item =
  | MitigationMeasures
  | PreventionMeasures
  | AffectedGroupState
  | FlammableCategory
  | OrganisationalMeasures
  | WorkerTrainingInformation;

type Props<T extends Item> = {
  otherKey?: keyof T;
  otherTxtKey?: keyof T;
  edmsKey?: keyof T;
  edmsTitle?: string;
  values: T;
  baseMessage: string;
};

function ReportChoices<T extends Item>({
  otherKey,
  otherTxtKey,
  values,
  baseMessage,
  edmsKey,
  edmsTitle,
}: Props<T>) {
  const keys = Object.keys(values) as Array<keyof T>;
  const { t } = useTranslation();

  return (
    <>
      {keys.map(key => {
        if (otherTxtKey && key === otherTxtKey) {
          if (otherKey && values[otherKey]) {
            return (
              <View style={styles.otherText}>
                <Text>{values[key] as string}</Text>
              </View>
            );
          }
          return <></>;
        }

        if (edmsKey && key == edmsKey) {
          return (
            <View style={styles.edmsText}>
              {edmsTitle && <Text>{edmsTitle}</Text>}
              <Link style={styles.link} href={getEDMSLink(values[key] as string)}>
                EDMS - {values[key] as string}
              </Link>
            </View>
          );
        }

        return (
          <View style={styles.optionWithCheckbox}>
            {values[key] ? <CheckboxSelectedSVG /> : <CheckboxSVG />}
            <Text>{t(`${baseMessage}.${key as string}`)}</Text>
          </View>
        );
      })}
    </>
  );
}

export default ReportChoices;
